import { Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * AppSimpleCardComponent - Microcomponente de card simples
 * Substitui mat-card em contextos simples
 *
 * @example
 * <app-simple-card
 *   title="Título"
 *   subtitle="Subtítulo"
 *   [elevated]="true"
 * >
 *   Conteúdo do card
 * </app-simple-card>
 */
@Component({
  selector: 'app-simple-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div [class]="getCardClasses()">
      <!-- Header -->
      @if (title() || subtitle()) {
      <div class="p-6 pb-4">
        @if (title()) {
        <h3 class="text-lg font-semibold text-gray-900 mb-1">{{ title() }}</h3>
        } @if (subtitle()) {
        <p class="text-sm text-gray-600">{{ subtitle() }}</p>
        }
      </div>
      }

      <!-- Content -->
      <div [class]="getContentClasses()">
        <ng-content></ng-content>
      </div>

      <!-- Footer -->
      @if (hasFooter()) {
      <div class="p-6 pt-4 border-t border-gray-200">
        <ng-content select="[slot=footer]"></ng-content>
      </div>
      }
    </div>
  `,
  styles: [],
})
export class AppSimpleCardComponent {
  @Input() title = signal('');
  @Input() subtitle = signal('');
  @Input() elevated = signal(false);
  @Input() bordered = signal(true);
  @Input() hasFooter = signal(false);

  getCardClasses(): string {
    let classes = 'bg-white rounded-lg transition-shadow duration-200';

    if (this.elevated()) {
      classes += ' shadow-lg hover:shadow-xl';
    } else {
      classes += ' shadow-sm hover:shadow-md';
    }

    if (this.bordered()) {
      classes += ' border border-gray-200';
    }

    return classes;
  }

  getContentClasses(): string {
    if (this.title() || this.subtitle()) {
      return 'px-6 pb-6';
    }
    return 'p-6';
  }
}
